// extracted by mini-css-extract-plugin
export default {"layout":"Page_layout__TzEV4","content":"Page_content__kbfFN","scroll":"Page_scroll__3T54H"};